export const GET_HOME_BANNERS = "GET_HOME_BANNERS"